import { render, staticRenderFns } from "./ErpApiSetting.vue?vue&type=template&id=f44cdd5e&scoped=true"
import script from "./ErpApiSetting.vue?vue&type=script&lang=js"
export * from "./ErpApiSetting.vue?vue&type=script&lang=js"
import style0 from "./ErpApiSetting.vue?vue&type=style&index=0&id=f44cdd5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44cdd5e",
  null
  
)

export default component.exports